import { render, staticRenderFns } from "./SwitchUrl.vue?vue&type=template&id=299771a5&"
import script from "WX/components/speedTest/SwitchUrl.component?vue&type=script&lang=js&"
export * from "WX/components/speedTest/SwitchUrl.component?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports